import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router';
import { setLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { isLoggedInWithBentleyToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { BentleyLogout } from '../logout/BentleyLogout';
import { Logout } from '../logout/Logout';
export const ErrorRedirect = () => {
    const [searchParams] = useSearchParams();
    const loginError = searchParams.get('error');
    const isLoggedInWithBentley = isLoggedInWithBentleyToken() || searchParams.get('bentley_token') === 'true';
    if (loginError) {
        setLoginError(loginError);
    }
    return isLoggedInWithBentley ? _jsx(BentleyLogout, {}) : _jsx(Logout, {});
};
//# sourceMappingURL=errorRedirect.js.map